import { CardBasic } from "@/components/ui-library-new/card/CardBasic"
import Richtext from "@/components/ui-library/richtext/Richtext"
import { BlokProps } from "@/helpers/StoryblokHelpers"
import { ImageContentSectionStoryblok } from "@/types/component-types"
import { cn } from "@/utils/utils"
import Col from "@ui-library/grid/Col"
import Row from "@ui-library/grid/Row"
import GridWrapper from "@ui-library/grid/Wrapper"
import Image from "next/image"

export const ImageContentSection = ({ blok }: BlokProps<ImageContentSectionStoryblok>) => {
  const row = (
    <Row alignItems="center">
      <Content blok={blok} />
    </Row>
  )

  return (
    <GridWrapper
      background={blok.background}
      className={cn(blok.as_card && blok?.variant ? "max-w-[1155px] py-16 md:mx-auto md:px-8" : "")}
    >
      {blok.as_card ? (
        <CardBasic variant={blok?.variant || "default"} className="mx-auto rounded-3xl">
          {row}
        </CardBasic>
      ) : (
        row
      )}
    </GridWrapper>
  )
}

const Content = ({ blok }: BlokProps<ImageContentSectionStoryblok>) => {
  return (
    <>
      {blok.content && (
        <Col grid={{ xs: 12, lg: 6 }} className={cn(blok.image_left && "order-2")}>
          <Richtext content={blok.content} />
        </Col>
      )}
      {blok.image?.filename && (
        <Col grid={{ xs: 12, lg: 6 }} className={cn(blok.image_left && "order-1")}>
          <Image
            src={blok.image?.filename}
            alt={blok.image?.alt || ""}
            width={640}
            height={0}
            sizes="(max-width: 768px) 100vw, 33vw"
            className="rounded-lg"
          />
        </Col>
      )}
    </>
  )
}
export default ImageContentSection
